<template>
  <div class="md:mt-16 md:mb-16 mt-8 mb-8 flex justify-center">
    <div class="flex flex-col collection-container">
      <div class="empty-collection-message">
        <img src="@/assets/Collection/emptyStateV2.svg" class="emptyStateImg" />
        <div class="emptyStateTitle">No Match Results Found</div>
        <span class="emptyStateText">
          We couldn't find a record matching the information provided.
        </span>
      </div>
      <div
        class="collection-contact relative cursor-pointer"
        @click="redirectToSupport"
      >
        <img
          src="@/assets/Collection/Support.svg"
          class="support-img absolute bottom-0 object-contain"
        />
        <div class="relative z-10 support-message">
          <span class="font-bold text-[#1e4670] instruction-title"
            >Need more help?</span
          >
          <span class="text-[#1e4670] flex items-center instruction-content"
            >Contact support
            <img
              src="@/assets/Collection/Arrow2.svg"
              class="ml-3 instruction-img"
            />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyStatePage',
  methods: {
    redirectToSupport() {
      window.open("https://www.vibrant-wellness.com/Contact/", "_blank");
    },
  },
};
</script>

<style scoped>
.collection-container {
  width: 808px;
}

.empty-collection-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}

.emptyStateTitle {
  font-size: 26px;
  font-weight: bold;
  color: #1e4670;
  margin-top: 20px;
  margin-bottom: 20px;
}

.emptyStateText {
  font-size: 18px;
  text-align: center;
  max-width: 808px;
  color: #1e4670;
}

.collection-contact {
  height: 156px;
  background: #fef6d7;
  border-radius: 8px;
  margin-top: 100px;
  margin-bottom: 30px;
  width: 100%;
  display: flex;
}

.support-img {
  width: 459px;
  margin-left: 35px;
}

.support-message {
  margin-left: 530px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 20px;
}

.instruction-title {
  font-family: Montserrat;
  font-size: 22px;
  margin-bottom: 16px;
}

.instruction-content {
  font-size: 16px;
}

@media only screen and (max-width: 768px) {
  .collection-container {
    width: 343px;
  }

  .emptyStateImg {
    width: 200px;
    height: auto;
    margin-top: 10px;
  }

  .emptyStateTitle {
    font-size: 14px;
    font-weight: bold;
    color: #1e4670;
    margin-top: 20px;
  }

  .emptyStateText {
    font-size: 12px;
    text-align: center;
    max-width: 343px;
  }

  .collection-contact {
    position: relative;
    margin-top: 40px;
    height: 120px;
  }

  .support-img {
    width: 272px;
    margin-left: 24px;
  }

  .support-message {
    margin-left: 55px;
    justify-content: flex-start;
    margin-top: 10px;
  }

  .instruction-title {
    font-size: 14px;
    margin-bottom: 2px;
  }

  .instruction-content {
    font-size: 12px;
  }

  .instruction-img {
    width: 20px;
  }
}
</style>
